import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import CustomValuesHook from '../../functions/myHooks/CustomValuesHook'
import moment from "moment-jalaali";
import { enToPersianChar } from './index';


const Details = ({ show, handleClose, details }) => {
    const [states, setStates] = CustomValuesHook({ columns: [] })

    useEffect(() => {
        let tempList = [];
        details?.data.forEach((item) => {
            let temp = []
            Object.keys(item.changesContentObject.Changes).forEach((key) => {

                temp.push(key)

            })
            if (!tempList.some(i => i === temp)) {
                tempList.push(temp)
            }

        })
        setStates({ columns: tempList })
    }, [])
    return (
        <Modal show={show} onHide={handleClose} animation={true} size='lg' dir="rtl" className="activity-details-modal">
            <Modal.Header>
                <Modal.Title className="d-flex justify-content-between w-100" >

                </Modal.Title>
            </Modal.Header>

            <Modal.Body className='invoice-modal-content-view'>
                <div>

                    {/* <table className='table table-bordered table-table' >
                        <thead>
                            <tr>
                                {states.columns[0].map((col, idx) => <th key={idx}>{col}</th>)}

                            </tr>
                        </thead>
                        <tbody>
                            {details?.data.map((item, idx) => {
                                return (
                                    <tr key={idx}>
                                        {states.columns[0].map((col, _idx) => {

                                            return (<td key={_idx}>{item.changesContentObject.Changes[col]}</td>)
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table> */}



                    <table className='table table-bordered table-table' >
                        <thead>
                            <tr>
                                <th>کاربر</th>
                                <th>تاریخ</th>
                                <th>userIp</th>
                                <th>eventHistoryId</th>
                                <th>eventHistoryTypeId</th>
                                <th>entityTypeEnum</th>

                                <th>تغییرات</th>

                            </tr>
                        </thead>
                        <tbody>
                            {details?.data.map((item, idx) => {
                                const date = item.time.split('T')[0]
                                const time = item.time.split('T')[1].split('.')[0]
                                const momentDate = moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm:ss').local('fa').format('jYYYY/jMM/jDD،HH:mm')

                                return <tr key={idx}>
                                    <td>{item.nameAndFamily}</td>
                                    <td>{enToPersianChar(momentDate)}</td>
                                    <td>{item.userIp}</td>
                                    <td>{item.eventHistoryId}</td>
                                    <td>{item.eventHistoryTypeId}</td>
                                    <td>{item.entityTypeEnum}</td>
                                    <td>

                                        {Object.keys(item.changesContentObject.Changes).map((key, index) => {
                                            if (key !== 'Id') {
                                                return (<div key={index} className='json-item'>
                                                    <label>{key} :</label> <b>{item.changesContentObject.Changes[key]}</b>
                                                </div>)
                                            } else {
                                                return null
                                            }

                                        })}

                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>
            </Modal.Body>


            <Modal.Footer className="d-flex flex-row justify-content-between">
                <button className="btn btn-primary" onClick={handleClose}>بستن</button>

            </Modal.Footer>
        </Modal>
    )
}

export default Details
